export const dateUtils = {

  formatDate: (date) => {

    let year = date.getFullYear();
    let month = date.getMonth() + 1; // sumamos 1 porque getMonth() devuelve 0 para enero
    let day = date.getDate();
  
    // Añadir ceros si el mes o el día es menor de 10
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
  
    return `${year}-${month}-${day}`;
  }

}

